export const CODEGUARD_BUY_URL = 'https://www.hostgator.com.br/backup-online';

export const videoEmbedUrl = 'https://www.youtube.com/embed/wvv4BGjsehA';
